/** Portal timestamps are stored in UTC on the server; display in UTC for consistency worldwide. */

const SERVER_TZ = 'UTC';

export function toUtcDate(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** YYYY-MM-DD in UTC (matches server date at creation). */
export function getServerDateString(value: string | Date | null | undefined): string {
  const date = toUtcDate(value);
  if (!date) return '';
  return date.toISOString().slice(0, 10);
}

export function formatServerDate(
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' }
): string {
  const date = toUtcDate(value);
  if (!date) return '—';
  return date.toLocaleDateString('en-US', { ...options, timeZone: SERVER_TZ });
}

export function formatServerTime(
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true }
): string {
  const date = toUtcDate(value);
  if (!date) return '—';
  return date.toLocaleTimeString('en-US', { ...options, timeZone: SERVER_TZ });
}

export function formatServerDateTime(value: string | Date | null | undefined): string {
  const date = toUtcDate(value);
  if (!date) return '—';
  return `${formatServerDate(date)} ${formatServerTime(date)} UTC`;
}
